import { render, staticRenderFns } from "./FormShareReport.vue?vue&type=template&id=24c76d32"
import script from "./FormShareReport.vue?vue&type=script&lang=js"
export * from "./FormShareReport.vue?vue&type=script&lang=js"
import style0 from "./FormShareReport.vue?vue&type=style&index=0&id=24c76d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports